import { connect } from 'react-redux'

import { trackIngredientsGetInTouchClick, trackIngredientsGoToMyGousto } from '../actions/getHelp'
import { getIneligibleIngredientsError } from '../selectors/orderSelectors'
import { IneligibleIngredients } from './IneligibleIngredients'

const IneligibleIngredientsContainer = connect(
  (state) => ({
    ineligibilityCriteria: getIneligibleIngredientsError(state),
  }),
  {
    trackIngredientsGetInTouchClick,
    trackIngredientsGoToMyGousto,
  },
)(IneligibleIngredients)

export { IneligibleIngredientsContainer }
